import { render, staticRenderFns } from "./IntegrationsMapping.vue?vue&type=template&id=0734e086"
import script from "./IntegrationsMapping.vue?vue&type=script&lang=js"
export * from "./IntegrationsMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports